<div class="row">
    <div class="col">
        <div class="row">
            <div class="col col-md-12 d-flex align-items-center">
                <h5><i class="fas fa-chart-pie text-primary"></i>
                    {{ usecase?.["name"] }} Pivot Chart
                </h5>
                <button (click)="downloadPDF()" title="PDF" class="pdf-exclude btn btn-outline-primary btn-sm ms-1">
                    <i class="fa fa-file-pdf"></i>
                </button>
                <button class="btn btn-sm btn-outline-primary ms-1"
                    title=" {{ showSearchInputs ? 'Hide Search Inputs' : 'Show Search Inputs' }}"
                    (click)="toggleSearchInputs()">
                    <i class="fa fa-search me-0" aria-hidden="true"></i>
                </button>
            </div>
            <div class="col-12 col-auto">
                <div class="card" #content1>
                    <div class="card-body">
                        <div class="card-header mb-2 ps-0 pe-0" *ngIf="showSearchInputs">
                            <div class="row g-2">
                                <ng-container *ngFor="let e of usecaseAttributes">
                                    <div *ngIf="e['refKey']==1" class="col-12 col-md-6 col-lg-2 ms-1">
                                        <select [(ngModel)]="searchValues[e.code]"
                                            (ngModelChange)="onSearchReferenceValueChange(e, $event)"
                                            class="form-select form-select-sm" id="{{e.code}}" name="{{e.code}}">
                                            <option value="">--Select {{e.code}} --</option>
                                            <option *ngFor="let c of form.preload?.[e['primaryUsecase']] || [] "
                                                value="{{c['id']}}">
                                                {{c['_val']}}</option>
                                        </select>
                                    </div>
                                    <div *ngIf="e['refKey']!=1 && e['type']!=='list'  && e['type']!=='file' && e['type']!=='map'"
                                        class="col-12 col-md-6 col-lg-2 ms-1">
                                        <input [type]="getInputType(e.type)" [(ngModel)]="searchValues[e['code']]"
                                            class="form-control form-control-sm" id="{{e['code']}}" name="{{e['code']}}"
                                            (ngModelChange)="onSearchValueChange(e, $event)" placeholder="{{e.label}}">
                                    </div>
                                    <div *ngIf="e['type']==='list'" class="col-12 col-md-6 col-lg-2 ms-1">
                                        <select [(ngModel)]="searchValues[e.code]" class="form-select form-select-sm"
                                            id="{{e.code}}" name="{{e.code}}">
                                            <option value="0">--Select-- {{e.code}}</option>
                                            <option *ngFor="let c of e['values']" value="{{c}}">{{c}}
                                            </option>
                                        </select>
                                    </div>
                                </ng-container>

                            </div>
                        </div>
                        <form class="px-3 py-3 mb-2" #pivotForm="ngForm">
                            <div class="pdf-exclude row">
                                <div class="col-auto">
                                    <div class="input-group mb-2">
                                        <button for="SelectAttributes" class="btn btn-outline-primary btn-sm">Row
                                        </button>
                                        <select class="form-select form-select-sm" id="SelectAttributes"
                                            name="SelectAttributes" [(ngModel)]="pivotform['index']" #SelectAttributes>
                                            <option value="">--Select--</option>
                                            <option *ngFor="let e of filterAttributes" value="{{e['label']}}">
                                                {{e["label"]}}
                                            </option>
                                        </select>
                                        <button (click)="updateFormField('index',SelectAttributes.value)"
                                            class="btn btn-outline-primary btn-sm">
                                            <i class="fa fa-plus"></i>
                                            Add
                                        </button>
                                    </div>
                                    <button *ngFor="let e of reqform['index']" (click)="removeFormField('index',e)"
                                        type="button" class="btn btn-outline-secondary btn-sm me-1 p-1 p-1"> {{e}}
                                        <i class="fa fa-times ms-1 fs-6"></i>
                                    </button>

                                </div>

                                <div class="col-auto">
                                    <div class="input-group mb-2">
                                        <button for="SelectColumn" class="btn btn-outline-primary btn-sm">Columns
                                        </button>
                                        <select class="form-select form-select-sm" id="SelectColumn" name="SelectColumn"
                                            [(ngModel)]="pivotform['columns']" #SelectColumn>
                                            <option value="">--Select--</option>
                                            <option *ngFor="let e of filterAttributes" value="{{e['label']}}">
                                                {{e["label"]}}
                                            </option>
                                        </select>
                                        <button (click)="updateFormField('columns',SelectColumn.value)"
                                            class="btn btn-outline-primary btn-sm">
                                            <i class="fa fa-plus"></i>
                                            Add
                                        </button>
                                    </div>
                                    <button *ngFor="let e of reqform['columns']" (click)="removeFormField('columns',e)"
                                        type="button" class="btn btn-outline-secondary btn-sm me-1 p-1 p-1"> {{e}}
                                        <i class="fa fa-times ms-1 fs-6"></i>
                                    </button>
                                </div>
                                <div class="col-auto">
                                    <div class="input-group mb-2">
                                        <button for="SelectValues" class="btn btn-outline-primary btn-sm">Values
                                        </button>
                                        <select class="form-select form-select-sm" id="SelectValues" name="SelectValues"
                                            [(ngModel)]="pivotform['values']" #SelectValues>
                                            <option value="">--Select--</option>
                                            <option *ngFor="let e of filterAttributes" value="{{e['label']}}">
                                                {{e["label"]}}
                                            </option>
                                        </select>
                                        <select class="form-select form-select-sm" name="aggType1" #aggType1>

                                            <option value="sum">Sum</option>
                                            <option value="mean">Mean</option>
                                            <option value="count">Count</option>
                                            <option value="min">Min</option>
                                            <option value="max">Max</option>
                                            <option value="std">Std</option>
                                            <option value="median">Median</option>
                                        </select>
                                        <button
                                            (click)="updateFormField('aggfunc',SelectValues.value,pivotform.value,true)"
                                            class="btn btn-outline-primary btn-sm">
                                            <i class="fa fa-plus"></i>
                                            Add
                                        </button>


                                    </div>
                                    <div *ngIf="reqform?.['aggfunc'] && objectEntries(reqform['aggfunc']).length">
                                        <button *ngFor="let entry of objectEntries(reqform['aggfunc'])"
                                            (click)="removeFormField('aggfunc', entry[0],true)" type="button"
                                            class="btn btn-outline-secondary btn-sm me-1 p-1">
                                            {{ entry[0] }} ({{ entry[1] }})
                                            <i class="fa fa-times ms-1 fs-6"></i>
                                        </button>
                                    </div>

                                </div>
                                <div class="col-auto">
                                    <div class="input-group mb-2">
                                        <button for="aggType" class="btn btn-outline-primary btn-sm">Type
                                        </button>
                                        <select class="form-select form-select-sm" id="chartType" name="chartType"
                                            [(ngModel)]="reqform['chart_type']">
                                            <!-- <option value="table">Table</option> -->
                                            <option value="html">Table</option>
                                            <option value="bar">Bar</option>
                                            <option value="line">Line</option>
                                            <option value="area">Area</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-auto">
                                    <button class="btn btn-outline-primary btn-sm" (click)="searchAndDraw()">Draw
                                    </button>
                                    <button (click)="resetSearchValues()" title="Refresh"
                                        class="pdf-exclude btn btn-outline-primary btn-sm">
                                        <i class="fa fa-eraser"></i>
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div class="table-responsive">
                            <p *ngIf="form['error'] == false && form['message']">
                                <app-ncs-alert [message]="form['message']" type="success" showAlert="true" />
                            </p>
                            <p *ngIf="form['error'] == true && form['message']">
                                <app-ncs-alert [message]="form['message']" type="danger" showAlert="true" />
                            </p>
                            <div *ngIf="loading"> loading ...</div>
                            <div *ngIf="!loading">
                                <div [innerHTML]="pivottable"> </div>
                                <img [src]="pivotUrl" width="100%">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>